import * as React from 'react'
import Select from 'react-select'
import Errors from './errors'
import Description from './description'
import FormGroup from './form-group'
import InputLabel from './input-label'
import { withStatus } from '../modules/status'
import { keys, map, find } from 'lodash'

import 'react-select/dist/react-select.css'
import './multi-selection-input.css'


@withStatus
export default class extends React.Component<any, any>{


    onHelpClick(e){
        this.props.actions.status.showMessage(null, this.props.help, null)
    }


    handleChange(selected){
        if(selected == null){
            this.props.updateField( this.props.field, null);
        }else{
            //Map the value supplied from the Select component to one suitable for the app
            if(this.props.multiselect){
                selected = selected.map(selection => selection.value)
            }else{
                selected = selected.value
            }
            this.props.updateField( this.props.field, selected);
        }
    }


    // Map the value supplied to this component into a format consumable by the Select component
    getValueByOptionsValue(appValue, options){
        if(appValue != 0 && !appValue) return null
        if(this.props.multiselect){
            return appValue.map(value => find(options, option => option.value === value))
        }else{
            return find(options, option => option.value === appValue)
        }
    }


    render(){
        const props = this.props
        const field = props.field
        const label = props.label
        const errors = props.errors
        const description = props.description
        const updateField = props.updateField
        const options = props.options
        const value = this.getValueByOptionsValue(this.props.value, options)
        const inline = props.inline || false
        const placeholder = this.props.placeholder ? this.props.placeholder : ""
        const show = props.show
        const size = props.size ? props.size : "col-sm-6"
        const help = this.props.help
        const clearable = this.props.clearable == null ? false : this.props.clearable;

        if(show == null || show){
            return (
                <div className={"selection-input col-12" + (!inline ? ` ${size}` : "")} id={field}>
                    <FormGroup field={ field } errors={ errors } >
                        <div className={"row" + (inline ? " d-flex align-items-center" : "")}>
                            <div className={ inline ? "col-12 col-sm-7" : "col-12"}>
                                <InputLabel field={ field } label={ label } help={ help }/>
                            </div>
                            <div className={ "input-group " + (inline ? "col-12 col-sm-5" : "col-12") + (help ? " no-border-right" : "") }>

                                <Select
                                    name={ field }
                                    value={ value }
                                    onChange={ this.handleChange.bind(this) }
                                    options={ options }
                                    multi={ this.props.multiselect }
                                    placeholder={ placeholder }
                                    searchable={ false }
                                    clearable={ clearable }
                                    autosize={ true }
                                />

                            </div>
                        </div>
                        <Errors errors={errors}/>
                        <Description description={ description } />
                    </FormGroup>
                </div>
            )
        }else{
            return null;
        }
    }

}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/multi-selection-input.tsx